import { css, polished, getAppStore } from 'jimu-core';
import { getBoxStyles } from 'jimu-theme';
function getRootStyles(root) {
    return css `
    display: block;
    width: 100%;
    -webkit-appearance: none;
    -moz-appearance: none;
    &:focus,
    &:active {
      outline: none;
    }
    &::-moz-focus-outer {
      border: none;
      outline: none;
    }
    ${getBoxStyles(root)}
    padding: 0;
    cursor: pointer;
    &.rtl {
      transform: rotate(180deg);
    }
  `;
}
function getThumbStyles(stateVars, hideThumb) {
    const { default: defaultVars, hover: hoverVars } = stateVars;
    return css `
    visibility: ${hideThumb ? 'hidden' : 'visible'};
    ${getBoxStyles(defaultVars)}
    box-sizing: border-box;
    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out; /* $btn-transition */
    ${hoverVars && css `
      &:hover {
        ${getBoxStyles(hoverVars)}
      }
    `}
  `;
}
function getTrackStyles(stateVars) {
    const { default: defaultVars } = stateVars;
    return css `
    ${getBoxStyles(defaultVars)}
  `;
}
function getVariantStyles(variantVars, hideThumb, isRTL) {
    const { track, thumb, progress } = variantVars;
    return css `
  &[type="range"] {
    /* thumb - webkit */
    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      ${getThumbStyles(thumb, hideThumb)};
    }
    /* thumb - moz */
    &::-moz-range-thumb {
      -moz-appearance: none;
      ${getThumbStyles(thumb, hideThumb)};
    }
    /* thumb - ms */
    &::-ms-thumb {
      ${getThumbStyles(thumb, hideThumb)};
      margin-top: 0;
    }
    /* track - webkit */
    &::-webkit-slider-runnable-track {
      ${getBoxStyles(track)};
      background: linear-gradient(to ${isRTL ? 'left' : 'right'}, ${progress.default.bg}, ${progress.default.bg}) ${track.bg} no-repeat left;
      background-size: 50% 100%, 100% 100%;
    }
    /* track - moz */
    &::-moz-range-track {
      ${getBoxStyles(track)};
    }
    /* track - ms */
    &::-ms-track {
      ${getBoxStyles(track)};
    }
    /* fill - moz */
    &::-moz-range-progress {
      ${getTrackStyles(progress)};
    }
    /* fill - ms */
    &::-ms-fill-lower {
      ${getTrackStyles(progress)};
    }
    &::-ms-fill-upper {
      display: none;
    }
    /* tooltip - ms */
    &::-ms-tooltip {
      display: none;
    }
    &:focus {
      &::-webkit-slider-thumb {
        box-shadow: ${thumb.focus.shadow};
      }
      &::-moz-range-thumb {
        box-shadow: ${thumb.focus.shadow};
      }
    }
  }`;
}
function getSizeStyles(size) {
    const { root, thumb } = size;
    return css `
    height: ${thumb};
    /* thumb - webkit */
    &::-webkit-slider-runnable-track {
      height: ${root};
    }
    /* track - moz */
    &::-moz-range-track {
      height: ${root};
    }
    /* track - ms */
    &::-ms-track {
      height: ${root};
    }

    /* fill - moz */
    &::-moz-range-progress {
      height: ${root};
    }
    /* fill - ms */
    &::-ms-fill-lower {
      height: ${root};
    }

    /* thumb - webkit */
    &::-webkit-slider-thumb {
      width: ${thumb};
      height: ${thumb};
      margin-top: -${polished.math(`
        (${thumb} - ${root}) * 0.5
      `)};
    }

    /* thumb - moz */
    &::-moz-range-thumb {
      width: ${thumb};
      height: ${thumb};
      margin-top: - ${polished.math(`
        (${thumb} - ${root}) * 0.5
      `)};
    }

    /* thumb - ms */
    &::-ms-thumb {
      width: ${thumb};
      height: ${thumb};
      margin-top: 0;
    }
  `;
}
export const sliderStyles = (props) => {
    var _a, _b, _c;
    const size = (_a = props.size) !== null && _a !== void 0 ? _a : 'default';
    const theme = props.theme;
    const hideThumb = props.hideThumb;
    const sliderVars = (_b = theme === null || theme === void 0 ? void 0 : theme.components) === null || _b === void 0 ? void 0 : _b.slider;
    const { sizes, variants } = sliderVars;
    const type = 'default';
    const isRTL = getAppStore().getState().appContext.isRTL;
    return sliderVars && css `
    ${getRootStyles((_c = variants[type]) === null || _c === void 0 ? void 0 : _c.root)}
    ${getSizeStyles(sizes[size])}
    ${getVariantStyles(variants[type], hideThumb, isRTL)}
  `;
};
export const sliderStyleUtils = { getRootStyles, getThumbStyles, getTrackStyles, getVariantStyles, getSizeStyles };
